<template>
  <div id="dashboard-patients-table">
    <Breadcrumbs
      :breadcrumbs="[
        {title: this.$t(`menu.${this.serviceSlug}`)},
        {title: this.$t('menu.checkup_plus/patients'), active: true, meta: {type: 'string', value: `/check-up_plus/checkup_plus/patients`}},
        {title: handlePatientName, disabled: true}
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <va-dropdown
          v-if="hasSomeActionsPermissions"
          class="custom-dropdown"
          fixed>
          <span slot="anchor">
            <slot>
              <div class="pl-3 pr-2 clickable">
                <span class="fa fa-ellipsis-v" style="font-size: 1.5rem;"></span>
              </div>
            </slot>
          </span>
          <div class="contact-dropdown__content pl-3 pr-2 pt-2 pb-2">
            <div v-if="canUpdateUser" class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                 @click.prevent="handleUpdatePatientPm">
              <div>
                <i class="fa fa-pencil"></i>
                {{ $t('dashboard_new_evollu.actions.edit_patient') }}
              </div>
            </div>
            <div v-if="canDeletePatient" class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                 @click.prevent="showStatusChangePatientModal = true">
              <div v-if="patientDetails !== null && patientDetails.status === 1">
                <i class="fa fa-lock"></i>
                {{ $t('dashboard_new_evollu.actions.disable_patient') }}
              </div>
              <div v-else>
                <i class="fa fa-unlock"></i>
                {{ $t('dashboard_new_evollu.actions.enable_patient') }}
              </div>
            </div>
            <div v-if="canDeletePatient" class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                 @click.prevent="showDeletePatient = true">
              <div>
                <i class="fa fa-times-circle"></i>
                {{ $t('dashboard_new_evollu.actions.delete_patient') }}
              </div>
            </div>
            <div v-if="patientDetails && patientDetails.isAwaitingPasswordChange"
                 class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                 @click.prevent="handleOneCareAppPassword">
              <i class="fa fa-key"></i>
              &nbsp;{{ $t('dashboard_new_evollu.actions.onecare_app_password') }}
            </div>
          </div>

        </va-dropdown>

        <UpdatePatient
          v-if="showUpdatePatient"
          :patientDetailsToEdit="this.patientDetails"
          @cancel="onCancelEdit"
        />

        <ConfirmationModal
          v-if="showStatusChangePatientModal"
          :title="$t('dashboard_new_evollu.modal.title_disable_patient')"
          :body="$t('dashboard_new_evollu.modal.modal_disable_patient', {name: patientDetails.name})"
          okClass="btn-danger"
          @modal-confirmed="onConfirmChangeStatus"
          @modal-canceled="onCancelChangeStatus"
        />
        <ConfirmationModal
          v-if="showDeletePatient"
          :title="$t('dashboard_new_evollu.modal.title_delete_patient')"
          :body="$t('dashboard_new_evollu.modal.modal_delete_patient', {name: patientDetails.name})"
          okClass="btn-danger"
          @modal-confirmed="onConfirmDeletePatient"
          @modal-canceled="onCancelDeletePatient"
        />

      </div>
    </Breadcrumbs>

    <div class="text-center" v-if="isLoadingPatientData">
      <LoadingAnimation/>
    </div>

    <div class="overlay-loader" v-if="downloadPdfReportLoading">
      <div class="blur-background"></div>
      <div class="overlay-message">
        <LoadingAnimation/>
        <h3>{{$t('checkup_plus.patient_details.downloading_report')}}</h3>
      </div>
    </div>

    <!-- ----------------------------- -->
    <!-- -------Patient Details------- -->
    <!-- ----------------------------- -->
    <div v-if="patientDetails !== null && patientDetails.status === 1 && !isLoadingPatientData" ref="patientDetails">
      <va-card>
        <div class="row col-12 col-md-12 d-flex justify--end">
          <!--<va-popover
            v-if="isFromEvollu && patientDetails && (hasPermissionToSendReportToPatient || hasPermissionToSendReportToPatientAndOthers)"
            placement="left"
            :message="patientDetails.email === null ? $t('dashboard_new_evollu.send_pdf_no_email') : $t('checkup_plus.patient_details.generate_report')">
            <va-button large icon="fa fa-file" color="#29C4AA" @click.prevent="handleGenerateReport()"
                       :disabled="isSendingPdf || patientDetails === null"></va-button>
          </va-popover>-->

          <va-popover
            v-if="patientDetails && (hasPermissionToSendReportToPatient || hasPermissionToSendReportToPatientAndOthers)"
            placement="top"
            :message="patientDetails.email === null ? $t('dashboard_new_evollu.send_pdf_no_email') : $t('dashboard_new_evollu.send_pdf')">
            <va-button large icon="fa fa-envelope" color="#29C4AA" @click.prevent="handleShowPdfReportOptionsModal('email')"
                       :disabled="isSendingPdf || patientDetails.email === null"></va-button>
          </va-popover>
          <va-popover
            placement="top"
            :message="$t('reports.reports.buttons.download_report')">
            <va-button large icon="fa fa-download" color="#29C4AA" @click.prevent="handleShowPdfReportOptionsModal('download')"
                       :disabled="downloadPdfReportLoading || patientDetails === null"></va-button>
          </va-popover>
        </div>
        <div class="row col-12 col-md-12">
          <div class="col-md-8">
            <h5>{{ $t('dashboard_new_evollu.titles.user_details') }} </h5>
            <div class="col-12 col-md-12 row">
              <div class="col-md-6" style="margin-left: -17px !important;">
                <p>{{ $t('dashboard_new_evollu.titles.title') }}:
                  <span class="is-bold">{{
                      patientDetails.title ? patientDetails.title : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>
                <p>{{ $t('dashboard_new_evollu.titles.name') }}:
                  <span class="is-bold">{{
                      patientDetails.name ? patientDetails.name : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>
                <!--<p>{{ $t('dashboard_new_evollu.titles.first_name') }}:
                  <span class="is-bold">{{
                      patientDetails.firstName ? patientDetails.firstName : patientDetails.name
                    }}</span>
                </p>
                <p>{{ $t('dashboard_new_evollu.titles.last_name') }}:
                  <span class="is-bold">{{
                      patientDetails.surname ? patientDetails.surname : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>-->
                <p>{{ $t('dashboard_new_evollu.titles.birthdate') }}:
                  <span class="is-bold">{{
                      patientDetails.dateOfBirth ? patientDetails.dateOfBirth : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>
                <p>Email:
                  <span class="is-bold">{{
                      patientDetails.email ? patientDetails.email : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>
                <p>{{ $t('dashboard_new_evollu.titles.mobile') }}:
                  <span class="is-bold">{{
                      patientDetails.countryCallingCode ? patientDetails.countryCallingCode + ' ' : ''
                    }}
                  {{patientDetails.mobile ? patientDetails.mobile : $t('dashboard_new_evollu.values.empty')}}</span>
                </p>
                <p>{{ $t('dashboard_new_evollu.titles.username') }}:
                  <span class="is-bold">{{
                      patientDetails.username ? patientDetails.username : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>
                <p>{{ $t('dashboard_new_evollu.titles.height') }}:
                  <span class="is-bold">{{
                      patientDetails.height ? patientDetails.height + " cm" : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>{{ $t('people_manager.tax_nr') }}:
                  <span class="is-bold">{{
                      patientDetails.taxNr ? patientDetails.taxNr : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>
                <p>{{ $t('people_manager.health_nr') }}:
                  <span class="is-bold">{{
                      patientDetails.healthNr ? patientDetails.healthNr : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>
                <p>{{ $t('dashboard_new_evollu.titles.address') }}:
                  <span class="is-bold">{{
                      handleAddress()
                    }}</span>
                </p>
                <p v-if="patientDetails.countryAlpha2Code && patientDetails.countryAlpha2Code.toLowerCase() !== 'pt' ">{{ $t('dashboard_new_evollu.titles.zipcode') }}:
                  <span class="is-bold">{{
                      handleZipCode()
                    }}</span>
                </p>
                <p>{{ $t('dashboard_new_evollu.titles.country') }}:
                  <span class="is-bold">{{
                      patientDetails.countryAlpha2Code ? handleCountry(patientDetails.countryAlpha2Code) : $t('dashboard_new_evollu.values.empty')
                    }}</span>
                </p>
              </div>
            </div>


            <!--<div class="col-12 col-md-12 row">
              <div class="col-md-6" style="margin-left: -17px !important;">
                <p>{{ $t('dashboard_new_evollu.titles.created_at') }}: <span class="is-bold">{{
                    patientDetails.created_at
                  }}</span></p>
              </div>
              <div class="col-md-6">
              </div>
            </div>-->
          </div>
          <div class="col-md-4">
            <h5>{{ $t('dashboard_new_evollu.titles.entity_details') }} </h5>
            <!--<p>{{ $t('dashboard_new_evollu.titles.name') }}:
              <span class="is-bold">{{ entityDetails.name }}</span>
            </p>-->
            <p>{{ $t('reports.templates.table.facilities') }}:
              <ul v-if="patientDetails.facilitiesEvollu && patientDetails.facilitiesEvollu.length >0">
                <li v-for="facility in patientDetails.facilitiesEvollu">
                  <span class="is-bold" :class="{ em: !patientDetails.facilitiesEvollu }">
                •{{ facility.name }}
              </span>
                </li>
              </ul>
              <span v-else class="is-bold" :class="{ em: !patientDetails.facilitiesEvollu }">
                {{
                  $t('dashboard_new_evollu.values.empty_facilities')
                }}
              </span>
            </p>

            <div v-if="patientDetails.evolluConsentId && true && patientDetails.evolluConsentId !== ''"
                 class="col-md-12 p-0">
            <span class="clickable" @click.prevent="handlePrivacyPolicyClick">
              <span class="clickable is-bold">{{ $t('leads.details.privacy_policy') }} </span>
              <i class="px-1 fa fa-external-link"></i>
            </span>
            </div>
          </div>
        </div>
      </va-card>
    </div>
    <!-- ----------------------------- -->
    <!-- -------Patient Details------- -->
    <!-- ----------------------------- -->
    <div v-if="canSeeMeasurements" >
      <!-- customization dropdown -->
      <div class="row d-flex justify--end mr-3" >
        <!-- Gear Icon -->
        <va-popover
          v-model="showCustomizationDropdown"
          placement="left"
          :title="$t('menu.configurations')"
          trigger="manual"
        >
          <i
            class="fa fa-gear clickable configuration-gear"
            style="font-size: 20px"
            @click.prevent="showCustomizationDropdown = !showCustomizationDropdown"
          />
        </va-popover>
        <div class="config-dropdown" v-if="showCustomizationDropdown">
          <draggable v-model="userConfig" handle=".drag-handle" :animation="100" @end="updateDraggableCardOrder">
            <div
              v-for="item in userConfig"
              :key="item.id"
              class="card-option"
            >
              <span class="drag-handle pr-1">☰</span>
              <input
                type="checkbox"
                :checked="!item.is_hidden"
                @change="item.is_hidden = !$event.target.checked"
                :id="item.id"
              />
              <span class="pl-2" :for="item.id">{{ $t(`dashboard_new_evollu.parameters.${addUnderscoreToUppercase(item.slug)}`) }}</span>

            </div>
          </draggable>

          <div class="row d-flex justify--end mr-3 mt-2">
            <i class="fa fa-save clickable" style="font-size: 20px; color:#29C4AABF" @click.prevent="handleSaveUserConfig(true)"/>
          </div>
        </div>
      </div>
      <!-- ---------------------- -->

      <!--DETAILED DATA FROM SELECTED CARD -->
      <div v-if="selectedCardData !== null">
        <div v-if="selectedCardData && selectedCardData.data.length > 0">
          <TableAndAudiologyTest
            v-if="selectedCardData && selectedCardData.identifier === 'audiology'"
            :data="selectedCardData.data"
            :columns="columnsByMeasurement[selectedCardData.originalIdentifier]"
            :measurementTitle="$t(`dashboard_new_evollu.parameters.${selectedCardData.identifier}`)"
            :icon="`i-checkup-${selectedCardData.identifier}`"
            :lastUpdate="selectedCardData.data.length > 0 ? selectedCardData.data[0].updated_at : 'N/A'"
            @collapse="selectedCardIdentifier = null"
          />
          <Mapa24Table
            v-else-if="selectedCardData && selectedCardData.identifier === 'mapa24'"
            :data="selectedCardData.data"
            :patientDetails="patientDetails"
            :columns="columnsByMeasurement[selectedCardData.originalIdentifier]"
            :measurementTitle="$t(`dashboard_new_evollu.parameters.${selectedCardData.identifier}`)"
            :icon="`i-checkup-${selectedCardData.identifier}`"
            :lastUpdate="selectedCardData.data.length > 0 ? selectedCardData.data[0].updated_at : 'N/A'"
            @collapse="selectedCardIdentifier = null"
          />
          <QuestionnairesTable
            v-else-if="selectedCardData && selectedCardData.identifier === 'checkup_anamnese'"
            :data="selectedCardData.data"
            :patientDetails="patientDetails"
            :columns="columnsByMeasurement[selectedCardData.originalIdentifier]"
            :measurementTitle="$t(`dashboard_new_evollu.parameters.${selectedCardData.identifier}`)"
            :icon="`i-checkup-${selectedCardData.identifier}`"
            :lastUpdate="selectedCardData.data.length > 0 ? selectedCardData.data[0].updated_at : 'N/A'"
            @collapse="selectedCardIdentifier = null"
          />
          <TableAndGraph
            v-else
            :allowShowProfileModal="selectedCardData.originalIdentifier === 'frailtyPhenotype' || selectedCardData.originalIdentifier === 'sarcopenia' || selectedCardData.originalIdentifier === 'ecg'"
            :hideMaxAvgMin="true"
            :data="selectedCardData.data"
            :patientDetails="patientDetails"
            :columns="columnsByMeasurement[selectedCardData.originalIdentifier]"
            :graphData="selectedCardData.chartData"
            :statsData="selectedCardData.statsData"
            @update_measurement="updateMeasurementTypeFromId"
            :canDeleteMeasurement="canDeleteMeasurement"
            :measurementTitle="$t(`dashboard_new_evollu.parameters.${selectedCardData.identifier}`)"
            :icon="`i-checkup-${selectedCardData.identifier}`"
            :lastUpdate="selectedCardData.data.length > 0 ? selectedCardData.data[0].updated_at : 'N/A'"
            @collapse="selectedCardIdentifier = null"
          />
        </div>
      </div>

      <!-- Measurements Cards -->
      <!--<div class="row collapsed-cards justify--center">
        <div v-for="elem in measurementCardsIdentifiers" class="position-relative">
          <i class="fa fa-bars clickable" style="font-size: 14px; z-index: 1000; position: absolute; right: 15px; top: 15px"></i>

          <MeasurementCard
            style="padding: 8px"
            v-if="elem.data"
            :title="$t(`dashboard_new_evollu.parameters.${elem.identifier}`)"
            :lastUpdate="elem.data.length > 0 ? elem.data[0].updated_at : 'N/A'"
            :isLoading="loading[elem.originalIdentifier]"
            :data="elem.data"
            :statsData="elem.statsData"
            :icon="`i-checkup-${elem.identifier}`"
            :class="{'selected-card-bg': selectedCardIdentifier && selectedCardIdentifier === elem.originalIdentifier}"
            @cardClicked="handleMeasurementCardExpand(elem.originalIdentifier)"
            @closeCardUpView="selectedCardIdentifier = null"
            :isSelected="selectedCardIdentifier && selectedCardIdentifier === elem.originalIdentifier"
            :canCreateMeasurement="canCreateMeasurement"
            :hideAddBtn="elem.originalIdentifier === 'audiology' || elem.originalIdentifier === 'sarcopenia' || elem.originalIdentifier === 'frailtyPhenotype' || elem.originalIdentifier === 'optometry' || elem.originalIdentifier === 'checkupAnamnesis' || elem.originalIdentifier === 'copd' || elem.originalIdentifier === 'urinary' || elem.originalIdentifier === 'biosignals' || elem.originalIdentifier === 'ecg'"
            :patientDetails="patientDetails"
            @handleCreateMeasurement="handleCreateMeasurement(elem.measurementTypeId)"
          />
        </div>
      </div>-->
      <draggable
        v-model="measurementCardsIdentifiers"
        item-key="originalIdentifier"
        handle=".clickable"
        class="row collapsed-cards justify--center"
        :animation="200"
      >
          <div class="position-relative" v-for="elem in measurementCardsIdentifiers">
            <i class="fa fa-bars clickable" style="font-size: 14px; z-index: 1000; position: absolute; right: 15px; top: 15px"></i>

            <MeasurementCard
              style="padding: 8px"
              v-if="elem.data"
              :title="$t(`dashboard_new_evollu.parameters.${elem.identifier}`)"
              :lastUpdate="elem.data.length > 0 ? elem.data[0].updated_at : 'N/A'"
              :isLoading="loading[elem.originalIdentifier]"
              :data="elem.data"
              :statsData="elem.statsData"
              :icon="`i-checkup-${elem.identifier}`"
              :class="{ 'selected-card-bg': selectedCardIdentifier && selectedCardIdentifier === elem.originalIdentifier }"
              @cardClicked="handleMeasurementCardExpand(elem.originalIdentifier)"
              @closeCardUpView="selectedCardIdentifier = null"
              :isSelected="selectedCardIdentifier && selectedCardIdentifier === elem.originalIdentifier"
              :canCreateMeasurement="canCreateMeasurement"
              :hideAddBtn="elem.originalIdentifier === 'audiology' || elem.originalIdentifier === 'sarcopenia' || elem.originalIdentifier === 'frailtyPhenotype' || elem.originalIdentifier === 'optometry' || elem.originalIdentifier === 'checkupAnamnesis' || elem.originalIdentifier === 'copd' || elem.originalIdentifier === 'urinary' || elem.originalIdentifier === 'biosigns' || elem.originalIdentifier === 'ecg'"
              :patientDetails="patientDetails"
              @handleCreateMeasurement="handleCreateMeasurement(elem.measurementTypeId)"
              @handleShowReferenceValuesModal="handleShowReferenceValuesModal(elem.data)"
              :hasReferenceValuesTable="elem.data.length > 0 && elem.data[0].referenceValuesTables !== null"
            />
          </div>
      </draggable>
      <!-- ------------------------------------------------->

      <div>
        <va-separator style="height: 8px; border-radius: 25px"/>
        <div>
          <RulesList
            :limitRules="patientDetails.limitRules"
            :person="patientDetails"
            :allowedMeasurementGroups="userEntityMeasurementGroupsPermited"
            @ruleDeleted="ruleDeleted"
          />
        </div>
      </div>

      <div v-if="canCreateMeasurement && !isLoading">
        <div class="btn btn__floating btn__round__large">
          <va-popover
            :message="$t('checkup_plus.person.measurements.new_measurement')"
            placement="top"
          >
            <va-button
              @click.prevent="showCreateMeasurementModal = true">
              <i class="fa fa-plus"></i>
            </va-button>

          </va-popover>
        </div>
      </div>


    </div>

    <CreateMeasurementModal
      v-if="canCreateMeasurement && showCreateMeasurementModal"
      :patientDetails="patientDetails"
      @cancel="onCancelCreateMeasurementModal"
      @measurementCreated="handleMeasuremenCreated"
      :allowedMeasurements="userEntityMeasurementGroupsPermited"
      :selectedMeasurementId="measurementIdToCreate"
    />

    <OneCareAppPasswordModal
      v-if="showOneCareAppPasswordModal"
      :patientDetails="patientDetails"
      @close="showOneCareAppPasswordModal = false"
    />

    <ReferenceValuesTableModal
      v-if="showReferenceValuesModal"
      :referenceValues="selectedReferenceValues"
      @cancel="closeReferenceValuesModal"
    />

    <ReportPdfOptionsModal
      v-if="showReportPdfOptionsModal"
      :actionType="reportActionType"
      @cancel="showReportPdfOptionsModal = false"
      @reportOptionsConfirm="reportPdfOptionsModalConfirmation"
    />
  </div>

</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import AudiologyDetails from "@/components/checkup_plus/patients/ParametersDetails/CollapsableCardWithBody";
import CollapsableCardWithBody from "@/components/checkup_plus/patients/ParametersDetails/CollapsableCardWithBody";
import HearingTest from "@/components/common/HearingTest";
import moment from "moment";
import TableAndGraphCard from "@/components/checkup_plus/patients/ParametersDetails/TableAndGraphCard";
import {OneCareService} from "@/api/OneCareService";
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import UpdatePatient from "@/components/checkup_plus/patients/UpdatePatient";
import TableAndAudiologyTestCard from "@/components/checkup_plus/patients/ParametersDetails/TableAndAudiologyTestCard";
import RulesList from "@/components/checkup_plus/patients/rules/RulesList.vue";
import MeasurementCard from "@/components/checkup_plus/patients/ParametersDetails/MeasurementCard.vue";
import TableAndGraph from "@/components/checkup_plus/patients/ParametersDetails/TableAndGraph.vue";
import TableAndAudiologyTest from "@/components/checkup_plus/patients/ParametersDetails/TableAndAudiologyTest.vue";
import Mapa24Table from "@/components/checkup_plus/patients/ParametersDetails/Mapa24/Table.vue";
import FadeTransition from "@/components/common/transitions/FadeTransition.vue";
import CreateMeasurementModal from "@/components/checkup_plus/patients/ParametersDetails/CreateMeasurementModal.vue"
import QuestionnairesTable
  from '@/components/checkup_plus/patients/ParametersDetails/Questionnaires/QuestionnairesTable.vue';
import * as countries from 'i18n-iso-countries'
import Vue from 'vue';
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin.vue';
import axios from '@/api/ApiService';
import OneCareAppPasswordModal from '@/components/checkup_plus/patients/OneCareAppPasswordModal.vue';
import { mapState } from 'vuex';
import { EntityService, UserService } from '@/api/AuthService';
import draggable from 'vuedraggable';
import { cloneDeep } from 'lodash';
import ReferenceValuesTableModal
  from '@/components/checkup_plus/patients/ParametersDetails/ReferenceValuesTableModal.vue';
import ReportPdfOptionsModal from '@/components/checkup_plus/patients/ReportPdfOptionsModal.vue';
import ReportPdfEmailDownload from '@/mixins/checkup/ReportPdfEmailDownload.vue';

const CHECKUP_ANAMNESE_MEASUREMENT_TYPE_ID = 1014
const BLOOD_PRESSURE_MEASUREMENT_TYPE_ID = 2
const TEMPERATURE_MEASUREMENT_TYPE_ID = 3
const GLUCOSE_MEASUREMENT_TYPE_ID = 4
const BODY_COMPOSITION_MEASUREMENT_TYPE_ID = 5
const SPIROMETRY_MEASUREMENT_TYPE_ID = 11
const OXIMETRY_MEASUREMENT_TYPE_ID = 18
const MAPA_24_MEASUREMENT_TYPE_ID = 20
const FRAILTY_PHENOTYPE_TYPE_ID = 6000
const SARCOPENIA_MEASUREMENT_TYPE_ID = 6001
const TONAL_TEST_MEASUREMENT_TYPE_ID = 9000
const OPTOMETRY_MEASUREMENT_TYPE_ID = 9050
const CHOLESTEROL_MEASUREMENT_TYPE_ID = 10000
const BODY_CIRCUMFERENCE_MEASUREMENT_TYPE_ID = 21
const COPD_MEASUREMENT_TYPE_ID = 22
const URINARY_MEASUREMENT_TYPE_ID = 24
const ADVANCED_GLUCOSE_MEASUREMENT_TYPE_ID = 25
const BLOOD_MEASUREMENT_TYPE_ID = 26
const REDOX_MEASUREMENT_TYPE_ID = 27
const LIVER_MEASUREMENT_TYPE_ID = 29
const BIOSIGNALS_MEASUREMENT_TYPE_ID = 23
const ECG_MEASUREMENT_TYPE_ID = 7


const PEOPLE_MANAGER_LIST_INFO_TYPE = 110

export default {
  name: "PatientDetails",
  mixins: [IsFromEvolluMixin, ReportPdfEmailDownload],
  components: {
    ReportPdfOptionsModal,
    ReferenceValuesTableModal,
    OneCareAppPasswordModal,
    QuestionnairesTable,
    FadeTransition,
    TableAndAudiologyTest,
    MeasurementCard,
    RulesList,
    TableAndAudiologyTestCard,
    LoadingAnimation,
    TableAndGraphCard,
    CollapsableCardWithBody,
    HearingTest,
    AudiologyDetails,
    Breadcrumbs,
    ConfirmationModal,
    UpdatePatient,
    TableAndGraph,
    Mapa24Table,
    CreateMeasurementModal,
    draggable
  },
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    },
  },
  async mounted() {
    this.error = null
    await this.loadData(true)
  },
  data: function () {
    return {
      showCustomizationDropdown: false,
      userConfig: null,
      originalUserConfig: null,
      canSeeMeasurements: false,
      /*measurementsTypesIds: [
        CHECKUP_ANAMNESE_MEASUREMENT_TYPE_ID,
        BLOOD_PRESSURE_MEASUREMENT_TYPE_ID,
        OXIMETRY_MEASUREMENT_TYPE_ID,
        SPIROMETRY_MEASUREMENT_TYPE_ID,
        TEMPERATURE_MEASUREMENT_TYPE_ID,
        BODY_COMPOSITION_MEASUREMENT_TYPE_ID,
        SARCOPENIA_MEASUREMENT_TYPE_ID,
        FRAILTY_PHENOTYPE_TYPE_ID,
        GLUCOSE_MEASUREMENT_TYPE_ID,
        CHOLESTEROL_MEASUREMENT_TYPE_ID,
        MAPA_24_MEASUREMENT_TYPE_ID,
        OPTOMETRY_MEASUREMENT_TYPE_ID,
        BODY_CIRCUMFERENCE_MEASUREMENT_TYPE_ID,
        COPD_MEASUREMENT_TYPE_ID,
        URINARY_MEASUREMENT_TYPE_ID,
        ADVANCED_GLUCOSE_MEASUREMENT_TYPE_ID,
        BLOOD_MEASUREMENT_TYPE_ID,
        REDOX_MEASUREMENT_TYPE_ID,
        LIVER_MEASUREMENT_TYPE_ID,
        BIOSIGNALS_MEASUREMENT_TYPE_ID,
        ECG_MEASUREMENT_TYPE_ID
      ],*/
      isLoading: true,
      isLoadingPatientData: true,
      measurementsData: null,
      patientDetails: null,
      entityDetails: {
        name: "",
        facility: ""
      },
      hearingTestData: null,
      audiologyData: [],
      audiologyStatsData: {},
      bloodPressureData: [],
      bloodPressureStatsData: {},
      oximetryData: [],
      oximetryStatsData: {},
      spirometryData: [],
      spirometryStatsData: {},
      temperatureData: [],
      temperatureStatsData: {},
      bodyCompositionData: [],
      bodyCompositionStatsData: {},
      sarcopeniaData: [],
      sarcopeniaStatsData: {},
      frailtyPhenotypeData: [],
      frailtyPhenotypeStatsData: {},
      glucoseData: [],
      glucoseStatsData: {},
      cholesterolData: [],
      cholesterolStatsData: {},
      mapa24Data: [],
      mapa24StatsData: {},
      optometryData: [],
      optometryStatsData: {},
      bodyCircumferenceData: [],
      bodyCircumferenceStatsData: {},
      copdData: [],
      copdStatsData: {},
      urinaryData: [],
      urinaryStatsData: {},
      advancedGlucoseData: [],
      advancedGlucoseStatsData: {},
      bloodData: [],
      bloodStatsData: {},
      redoxData: [],
      redoxStatsData: {},
      liverData: [],
      liverStatsData: {},
      biosignsData: [],
      biosignsStatsData: {},
      ecgData: [],
      ecgStatsData: {},
      isSendingPdf: false,
      canBlockOrDeleteUser: true,
      showStatusChangePatientModal: false,
      showDeletePatient: false,
      showUpdatePatient: false,

      loading: {
        audiology: true,
        bloodPressure: true,
        oximetry: true,
        spirometry: true,
        temperature: true,
        bodyComposition: true,
        sarcopenia: true,
        frailtyPhenotype: true,
        glucose: true,
        cholesterol: true,
        mapa24: true,
        optometry: true,
        bodyCircumference: true,
        checkupAnamnese: true,
        copd: true,
        urinary: true,
        advancedGlucose: true,
        blood: true,
        redox: true,
        liver: true,
        biosigns: true,
        ecg: true,
      },
      columnsByMeasurement: {
        audiology: ['created_at', 'hl_left', 'hl_right', 'hl', 'automatic'],
        bloodPressure: ['created_at', 'systolic', 'diastolic', 'heart_rate', 'automatic', 'notes'],
        oximetry: ['created_at', 'duration_session', 'oximetry_max', 'oximetry_min', 'oximetry_avg', 'pulse_rate_max', 'pulse_rate_min', 'pulse_rate_avg', 'automatic', 'notes'],
        glucose: ['created_at', 'blood_glucose', 'fasting', 'automatic'],
        spirometry: ['created_at', 'forced_expiratory_volume_6_sec', 'forced_expiratory_volume_1_sec', 'fev1_fev6', 'forced_mid_expiratory_flow_25_75', 'automatic'],
        temperature: ['created_at', 'body_temperature', 'automatic'],
        bodyComposition: ['created_at', 'body_weight', 'body_mass_index', 'body_water_percentage', 'body_fat_percentage', 'body_muscle_mass', 'automatic'],
        sarcopenia: ['created_at', 'sarc_f', 'hand_grip', 'body_muscle_mass', 'gait_speed', 'automatic'],
        frailtyPhenotype: ['created_at', 'frailty_exhaustion_result', 'frailty_physical_activity', 'frailty_walk_time', 'frailty_dominant_strength', 'frailty_weight_loss', 'automatic'],
        cholesterol: ['created_at', 'cholesterol_total', 'hdl_cholesterol', 'ldl_cholesterol', 'triglycerides', 'cv_risk', 'automatic'],
        mapa24: ['created_at', 'measurement_type', 'automatic'],
        optometry: ['created_at', 'optometry_result', 'astigmatism', 'duochrome', 'chromatic_correct', 'contrast', 'macular', 'acuity'],
        bodyCircumference : ['created_at', 'waist_perimeter', 'abdomen_perimeter', 'chest_perimeter', 'relaxed_arm_perimeter', 'thigh_perimeter', 'calf_perimeter'],
        checkupAnamnese: ['created_at','measurement_type', 'automatic'],
        copd: ['created_at', 'forced_expiratory_volume_6_sec', 'forced_expiratory_volume_1_sec', 'forced_expiratory_volume_1_sec_predicted', 'fev1_fev6', 'forced_mid_expiratory_flow_25_75', 'copd_mmrc', 'respiratory_crisis', 'respiratory_hospitalization',  'automatic'],
        urinary: ['created_at', 'urinary_leu', 'urinary_ket', 'urinary_nit', 'urinary_uro', 'urinary_bil', 'urinary_pro', 'urinary_glu', 'urinary_sg', 'urinary_bld', 'urinary_ph', 'urinary_vc', 'automatic'],
        advancedGlucose: ['created_at', 'advanced_glucose_glucose', 'advanced_glucose_hemoglobin_glycated', 'advanced_glucose_estimated_average', 'automatic'],
        blood: ['created_at', 'blood_hematocrit', 'blood_erythocytes', 'blood_hemoglobin', 'automatic'],
        redox: ['created_at', 'redox_fort', 'redox_ford', 'redox_uric_acid', 'redox_index', 'automatic'],
        liver: ['created_at', 'liver_gpt_transsaminases', 'liver_got_transsaminases', 'liver_gpt_got_transsaminases', 'automatic'],
        biosigns: ['created_at', 'biosigns_heart_rate', 'biosigns_variability_heart_rate', 'biosigns_bp_systolic', 'biosigns_bp_diastolic', 'biosigns_respiratory_rate', 'biosigns_oxygen_saturation', 'biosigns_stress_index', 'biosigns_activity', 'biosigns_health', 'biosigns_relaxation', 'biosigns_metabolism', 'biosigns_sleep', 'biosigns_equilibrium', 'biosigns_total_cholesterol', 'biosigns_hemoglobin', 'biosigns_hba1c', 'automatic'],
        ecg: ['created_at', 'ecg_heart_rate_status', 'ecg_bp_atrial_fibrillation', 'ecg_measurement_status', 'automatic']
      },
      selectedCardIdentifier: null,
      showCreateMeasurementModal: false,
      measurementIdToCreate: null,
      checkupAnamneseData: [],
      checkupAnamneseStatsData: {},
      showOneCareAppPasswordModal: false,
      userEntityMeasurementGroupsPermited: [],
      selectedReferenceValues: null,
      showReferenceValuesModal: false,
    }
  },
  methods: {

    async parseDataForJsReport(data) {
      let finalData = {}
      const colours = {
        "BIO_PARAM": {
          primaryColor: "#6D98F4",
          secondaryColor: "#D9E4FC",
          descriptionTextColor: "#b8c7ea",
        },
        "GERIATRICS": {
          primaryColor: "#8F76DB",
          secondaryColor: "#EDE9FA",
          descriptionTextColor: "#c7bcea"
        },
        "AUDIOLOGY": {
          primaryColor: "#FFA564",
          secondaryColor: "#FFF3EB",
          descriptionTextColor: "#fbe5d1"
        },
        "OPTOMETRY": {
          primaryColor: "#F9679E",
          secondaryColor: "#FADEEA",
          descriptionTextColor: "#fbcce1"
        },
        "COMPLEX_MONITORING": {
          primaryColor: "#6D98F4",
          secondaryColor: "#D9E4FC",
          descriptionTextColor: "#b8c7ea"
        },
        "BIO_SIGNS": {
          primaryColor: "#4DB889",
          secondaryColor: "#b7d5c8",
          descriptionTextColor: "#7dd3ae"
        },
        "BIOCHIMICAL_PARMS": {
          primaryColor: "#91D6D9",
          secondaryColor: "#E4F5F5",
          descriptionTextColor: "#b6d5d5"
        }
      }
      finalData.data = { ...data }
      finalData.data.resultsByGroupClassification.forEach(elem => {
        if (!Object.keys(colours).includes(elem.groupClassificationSlug)) {
          elem.primaryColor = "#6D98F4"
          elem.secondaryColor = "#D9E4FC"
          elem.descriptionTextColor = "#b8c7ea"
        } else {
          elem.primaryColor = colours[elem.groupClassificationSlug].primaryColor
          elem.secondaryColor = colours[elem.groupClassificationSlug].secondaryColor
          elem.descriptionTextColor = colours[elem.groupClassificationSlug].descriptionTextColor
        }

        elem.groupResults.forEach(elem => {
          if (elem.lastMeasurementTimestamp) {
            elem.lastMeasurementStrDate = moment(elem.lastMeasurementTimestamp).format('DD/MM/YYYY')
          } else {
            elem.lastMeasurementStrDate = null
          }

          if (elem.measurementTimestamp) {
            elem.measurementStrDate = moment(elem.measurementTimestamp).format('DD/MM/YYYY HH:mm')
          } else {
            elem.measurementStrDate = null
          }


          elem.measurementValues.forEach(measValue => {
            measValue.attributeName = measValue.attributeName.toLowerCase().replace(/\s+/g, '_');
            switch(measValue.attributeCode){
              case "OPT_AST_L":
              case "OPT_AST_R":
              case "OPT_DUOCH":
              case "OPT_MAC_L":
              case "OPT_MAC_R":
                measValue.value = measValue.value !== null && measValue.value !== "" ? this.$t(`optometry.leads.results.${measValue.value}`) : measValue.value
                measValue.previousValue = measValue.previousValue !== null && measValue.previousValue !== "" ? this.$t(`optometry.leads.results.${measValue.previousValue}`) : measValue.previousValue
                break;
            }
          })

          elem.results.forEach(result => {
            let parsedReferenceValues = []
            result.referenceValues.forEach(refValue => {
              var str = ""
              if(refValue.observations) {
                str = refValue.observations
              } else {
                let index = 0
                let criteriasLength = refValue.criteriaList ? refValue.criteriaList.length ? refValue.criteriaList : 0 : 0
                if (refValue.operator === "AND") {
                  refValue.criteriaList.forEach(elem => {
                    const translatedAttributeName = elem.attributeName ? this.$t(`dashboard_new_evollu.measurement_types.${elem.attributeName.toLowerCase().replace(/ /g, '_')}_short`) : elem.attributeName
                    str += `${translatedAttributeName} ${elem.criteria} ${elem.units && elem.units !== null ? elem.units : ''}`+ ' '
                    ++index
                    if (index < criteriasLength) {
                      str += "& "
                    }
                  })
                } else if (refValue.operator === "OR") {
                  refValue.criteriaList.forEach(elem => {
                    const translatedAttributeName = elem.attributeName ? this.$t(`dashboard_new_evollu.measurement_types.${elem.attributeName.toLowerCase().replace(/ /g, '_')}_short`) : elem.attributeName
                    str += `${translatedAttributeName} ${elem.criteria} ${elem.units && elem.units !== null ? elem.units : ''}` + ' '
                    ++index
                    if (index < criteriasLength) {
                      str += `${this.$t('or')} `
                    }
                  })
                }
              }


              parsedReferenceValues.push({
                criteria: str,
                resultMatchingCriteria: refValue.resultMatchingCriteria,
                observations: refValue.observations,
                observation1: refValue.observations ? refValue.observations.split(':')[0] : null,
                observation2: refValue.observations ? refValue.observations.split(':')[1] : null
              })
            })
            result.parsedReferenceValues = parsedReferenceValues
          })

        })
      })
      finalData.data.patientDetails.consultationDate = finalData.data.patientDetails.date
      finalData.data.patientDetails.age = moment().diff(moment(finalData.data.patientDetails.birthdate, 'DD/MM/YYYY'), 'years')


      //Handle entity icon
      let logoUrl = null
      let baseUrl = process.env.VUE_APP_AUTH_URL
      if (finalData.data.patientDetails.entityId !== null) {
        const response = await fetch(`${baseUrl}/entities/${finalData.data.patientDetails.entityId}/icon`, { method: 'HEAD' });
        if(response.ok) { logoUrl = `${baseUrl}/entities/${finalData.data.patientDetails.entityId}/icon`}
      }

      finalData.data.patientDetails.entityLogoUrl = logoUrl

      finalData.template = {
        name: "/checkup/checkup-main"
      }
      finalData.options = {
        localization: {
          language: "pt"
        }
      }

      return finalData
    },
    handleUpdatePatientPm() {
      if(!this.patientDetails.peopleManagerId || !this.peopleManagerService) return
      this.$router.push({ name: `${this.peopleManagerService.slug}/people-manager/list/patient/id`, params: { id: this.patientDetails.peopleManagerId, showEdit: true } })
    },
    handleCountry(isoCountryCode) {
      const country = this.countries.find(country => country.code.toLowerCase() === isoCountryCode.toLowerCase() )
      return country ? country.name : "N/A"
    },
    handleMeasurementCardExpand(identifier) {
      this.selectedCardIdentifier = identifier
      this.scrollToOverviewCard()
    },
    scrollToOverviewCard() {
      var element = this.$refs["patientDetails"];
      element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
    },
    handleCreateMeasurement(measurementTypeId) {
      this.measurementIdToCreate = measurementTypeId
      this.showCreateMeasurementModal = true
    },
    async handleMeasuremenCreated(measurementData, identifier) {
      this.loading[identifier] = true
      this.isLoading = true
      await this.getMeasurementDataFromTypeId(measurementData.measurementGroup.idMeasurementGroup)
      this.isLoading = false
      this.loading[identifier] = false
      this.measurementIdToCreate = null
      this.showCreateMeasurementModal = false
    },
    onCancelCreateMeasurementModal() {
      this.showCreateMeasurementModal = false;
      this.measurementIdToCreate = null
    },
    handleShowReferenceValuesModal(measData) {
      this.selectedReferenceValues = measData[0].referenceValuesTables
      this.showReferenceValuesModal = true
    },
    closeReferenceValuesModal() {
      this.selectedReferenceValues = null
      this.showReferenceValuesModal = false
    },
    ruleDeleted: function (rule) {
      const idx = this.patientDetails.limitRules.findIndex(elem => elem.limitRuleId === rule.limitRuleId)
      if (idx !== null && idx !== undefined) {
        this.patientDetails.limitRules.splice(idx, 1)
      }
    },
    handlePrivacyPolicyClick: function () {
      window.open(`${process.env.VUE_APP_CONSENT_URL}v1/consent/${this.patientDetails.evolluConsentId}`);
    },
    handleAddress: function() {
      let addressStr = ''
      if (this.patientDetails && this.patientDetails.address) {
        addressStr += this.patientDetails.address + " "
      }
      if(this.patientDetails.countryAlpha2Code.toLowerCase() === 'pt') {
        if(this.patientDetails.municipio) {
          addressStr += ", "+ this.patientDetails.municipio.name
        }
        if(this.patientDetails.municipio && this.patientDetails.municipio.districtName && this.patientDetails.municipio.districtName !== '') {
          addressStr += ', '+this.patientDetails.municipio.districtName + ' '
        } else {
          addressStr +=' '
        }
      } else {
        if(this.patientDetails && this.patientDetails.county) {
          addressStr += ", " + this.patientDetails.county + " "
        }
      }

      if (this.patientDetails.zipPrefix && this.patientDetails.zipPrefix !== '') {
        addressStr += ", "+this.patientDetails.zipPrefix
      }
      if (this.patientDetails.zipSufix && this.patientDetails.zipSufix !== '') {
        addressStr += `-${this.patientDetails.zipSufix}`
      }

      return addressStr === '' ? "N/A" : addressStr
    },
    handleZipCode: function () {
      let zipCode = ''
      if (this.patientDetails.zipPrefix && this.patientDetails.zipPrefix !== '') {
        zipCode += this.patientDetails.zipPrefix
      }
      if (this.patientDetails.zipSufix && this.patientDetails.zipSufix !== '') {
        zipCode += `-${this.patientDetails.zipSufix}`
      }
      return zipCode !== '' ? zipCode : "N/A"
      //patientDetails.zipPrefix ? `${patientDetails.zipPrefix}-${patientDetails.zipSufix}` : $t('dashboard_new_evollu.values.empty')
    },
    loadPermittedUserEntityMeasurementGroups: async function() {
      const data = await EntityService.getCheckupEntityMeasurementGroups(this.$auth.user().entity_id)
      const groupIdsSet = new Set(data.map(e => e.checkup_measurement_group_id));
      this.userEntityMeasurementGroupsPermited = this.measurementTypesInfo.filter(meas =>
        groupIdsSet.has(meas.measurementGroupId)
      );
    },
    loadUserConfig: async function() {
      try {
        const configData = await UserService.getCheckupScreenUserConfig()
        this.parseUserConfigData(configData)
      } catch (e) {
        console.error(`Error getting checkup user config: ${e}`)
      }

    },
    updateDraggableCardOrder() {
      this.userConfig.forEach((item, index) => {
        item.order = index + 1
      })
    },
    parseUserConfigData: function(configData) {
      if(!configData || configData.length === 0) {
        this.userConfig = this.userEntityMeasurementGroupsPermited.map((perm, idx) =>  {
          return {
            id: idx + 1,
            checkup_measurement_group_id: perm.measurementGroupId,
            order: idx + 1,
            is_hidden: false,
            slug: perm.slug
          }
        })
        this.originalUserConfig = cloneDeep(this.userConfig)
      } else {
        let userConfig = []
        this.userEntityMeasurementGroupsPermited.forEach(perm => {
          const elem = configData.find(elem => elem.checkup_measurement_group_id === perm.measurementGroupId)
          if(elem) {
            userConfig.push({
              id: elem.id,
              checkup_measurement_group_id: elem.checkup_measurement_group_id,
              order: elem.order,
              is_hidden: elem.is_hidden,
              slug: perm.slug
            })
          }
        })
        userConfig = userConfig.sort((a, b) => a.order - b.order)
        this.userConfig = userConfig
        this.originalUserConfig = cloneDeep(this.userConfig)
      }
    },
    handleSaveUserConfig: async function(fetchMeasurements) {
      const data = this.userConfig.map(elem => {
        return {
          checkup_measurement_group_id: elem.checkup_measurement_group_id,
          order: elem.order,
          is_hidden: elem.is_hidden
        }
      })
      const res = await UserService.updateCheckupScreenUserConfig(data)
      this.parseUserConfigData(res)
      if (fetchMeasurements && this.canSeeMeasurements) {
        await this.fetchMeasurements()
      }
    },
    loadData: async function (fetchMeasurements) {
      this.isLoading = true
      this.isLoadingPatientData = true

      try {
        this.patientDetails = await OneCareService.getPatient(this.$route.params.id)
        await this.loadPermittedUserEntityMeasurementGroups()
        await this.loadUserConfig()
        await this.handleCanSeeMeasurements()

        this.patientDetails.dateOfBirth = moment(this.patientDetails.dateOfBirth).format('YYYY-MM-DD')
        if (this.patientDetails.municipio === null) {
          this.patientDetails.municipio = {}
        }
        this.isLoadingPatientData = false
      } catch (e) {
        console.log("Error fetching patient data: " + e.message)
      }

      //handle tonalTestData

      if (fetchMeasurements && this.canSeeMeasurements) {
        await this.fetchMeasurements()
      }
      this.isLoading = false
    },
    fetchMeasurements: async function () {
      //Only get audiology if it is an allowed measurement
      //Get only if also is visible in the user config
      if(this.userEntityMeasurementGroupsPermited.some(elem => elem.measurementGroupId === TONAL_TEST_MEASUREMENT_TYPE_ID) && this.userConfig.some(elem => elem.checkup_measurement_group_id === TONAL_TEST_MEASUREMENT_TYPE_ID && elem.is_hidden === false)) {
        const audiologyData = await OneCareService.getPatientMeasurements(this.$route.params.id, TONAL_TEST_MEASUREMENT_TYPE_ID)
        this.parseTonalTestData(audiologyData.objects)
      }

      const allowedGroupsIds = this.userEntityMeasurementGroupsPermited.map(elem => elem.measurementGroupId)
      //for (const id of this.measurementsTypesIds) {
      for (const id of allowedGroupsIds) {
        //Get only for the userConfig visible ones
        if(this.userConfig.some(elem => elem.checkup_measurement_group_id === id && elem.is_hidden === false)) {
          try {
            await this.getMeasurementDataFromTypeId(id)
          } catch (e) {
            console.error(`Request for measurement with id ${id} has errored`)
            console.log(e)
          }
        }
      }
    },
    parseTonalTestData: function (data) {
      const HEAR_LOSS_LEFT_TYPE_ID = 9009
      const HEAR_LOSS_RIGHT_TYPE_ID = 9010
      const HEAR_LOSS_RESULT_TYPE_ID = 9011

      this.audiologyData = []
      const frequenciesToTypeIdMapping = {
        9001: {side: 'left', freq: 1000},
        9002: {side: 'left', freq: 2000},
        9003: {side: 'left', freq: 4000},
        9004: {side: 'left', freq: 6000},
        9005: {side: 'right', freq: 1000},
        9006: {side: 'right', freq: 2000},
        9007: {side: 'right', freq: 4000},
        9008: {side: 'right', freq: 6000},
        9012: {side: 'left', freq: 500},
        9013: {side: 'right', freq: 500},
      }

      let lastChartResultStr = "N/A"

      let lastResults = [];
      let isIndividualResult = null

      let lastChartResults = []
      if(data.length) {
        lastChartResults = data[0].chartResults
        /*if(lastChartResults.length > 0) {
          lastChartResultStr= this.$t(`dashboard_new_evollu.parameters.graphs.legends.${lastChartResults[0].code.toLowerCase()}`)
        }*/

        if(lastChartResults && lastChartResults.length > 0) isIndividualResult = lastChartResults.length === 1

        if (lastChartResults && lastChartResults.length === 1) {
          lastChartResultStr = this.$t(`dashboard_new_evollu.parameters.graphs.legends.${lastChartResults[0].code.toLowerCase()}`);
          lastResults.push(lastChartResultStr);
        } else if (lastChartResults && lastChartResults.length > 1) {
          lastChartResults.forEach(res => {
            lastResults.push(this.$t(`dashboard_new_evollu.parameters.graphs.legends.${res.code.toLowerCase()}`));
          })
        }
      }

      data.forEach(elem => {
        let results = {
          left: {},
          right: {}
        }

        elem.measurements.forEach(elem => {
          if (frequenciesToTypeIdMapping[elem.typeId]) {
            const side = frequenciesToTypeIdMapping[elem.typeId].side
            const freq = frequenciesToTypeIdMapping[elem.typeId].freq
            if (side && freq) {
              results[side][freq] = elem.value
            }
          }
        })
        let resultStr = ''
        if(results.left['500']) {
          resultStr = `F\t500\t1000\t2000\t4000\t6000\nR\t${results.right['500']}\t${results.right['1000']}\t${results.right['2000']}\t${results.right['4000']}\t${results.right['6000']}\nL\t${results.left['500']}\t${results.left['1000']}\t${results.left['2000']}\t${results.left['4000']}\t${results.left['6000']}`
        } else {
          resultStr = `F\t1000\t2000\t4000\t6000\nR\t${results.right['1000']}\t${results.right['2000']}\t${results.right['4000']}\t${results.right['6000']}\nL\t${results.left['1000']}\t${results.left['2000']}\t${results.left['4000']}\t${results.left['6000']}`
        }


        const referenceValuesTables = elem.referenceValuesTables
        if(referenceValuesTables) {
          referenceValuesTables.measurementType = "audiology"
        }
        this.audiologyData.push({
          created_at: moment(elem.date).format('YYYY-MM-DD HH:mm'),
          updated_at: moment(elem.date).format('YYYY-MM-DD HH:mm'),
          hl_left: this.checkStringValueNotUndefinedAndReturn(elem.measurements.filter(elem => elem.typeId === HEAR_LOSS_LEFT_TYPE_ID)[0], ''),
          hl_right: this.checkStringValueNotUndefinedAndReturn(elem.measurements.filter(elem => elem.typeId === HEAR_LOSS_RIGHT_TYPE_ID)[0], ''),
          hl: this.parseBoolean(this.checkStringValueNotUndefinedAndReturn(elem.measurements.filter(elem => elem.typeId === HEAR_LOSS_RESULT_TYPE_ID)[0], '')),
          hl_raw: parseInt(this.checkStringValueNotUndefinedAndReturn(elem.measurements.filter(elem => elem.typeId === HEAR_LOSS_RESULT_TYPE_ID)[0], '')),
          result_graph_str: resultStr,
          automatic: elem.automatic,
          appointmentId: elem.appointmentId,
          appointment: elem.appointment,
          last_chart_result: lastChartResultStr,
          lastResults: lastResults,
          lastChartResultObj: lastChartResults || [],
          referenceValuesTables: referenceValuesTables,
          isIndividualResult: isIndividualResult
        })

        if(data.length > 0) {
          let audiologyStatsData = {
            'hl_left': {},
            'hl_right': {},
            'hl': {}
          }

          audiologyStatsData.hl_left['last'] = this.checkStringValueNotUndefinedAndReturn(data[0].measurements.find(elem => elem.typeId === HEAR_LOSS_LEFT_TYPE_ID), 'dB')
          audiologyStatsData.hl_right['last'] = this.checkStringValueNotUndefinedAndReturn(data[0].measurements.find(elem => elem.typeId === HEAR_LOSS_RIGHT_TYPE_ID), 'dB')
          audiologyStatsData.hl['last'] = this.parseBoolean(this.checkStringValueNotUndefinedAndReturn(data[0].measurements.find(elem => elem.typeId === HEAR_LOSS_RESULT_TYPE_ID), ''))
          this.audiologyStatsData = {...audiologyStatsData}
        }
      })
      this.loading.audiology = false
    },
    updateMeasurementTypeFromId: function (measurementTypeId) {
      this.getMeasurementDataFromTypeId(measurementTypeId)
    },
    getMeasurementDataFromTypeId: async function (measurementTypeId) {
      const data = await OneCareService.getPatientMeasurements(this.$route.params.id, measurementTypeId, measurementTypeId !== FRAILTY_PHENOTYPE_TYPE_ID)
      if (data.objects.length > 0) {
        switch (data.objects[0].measurementGroup.idMeasurementGroup) {
          case BLOOD_PRESSURE_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: BLOOD_PRESSURE_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'bloodPressure',
              measurementTypes: [
                { typeId: 2, label: 'systolic', unit: 'mmHg', ignoreForStats: false },
                { typeId: 3, label: 'diastolic', unit: 'mmHg', ignoreForStats: false },
                { typeId: 4, label: 'heart_rate', unit: 'bpm', ignoreForStats: false },
              ]
            });
            //this.parseBloodPressureData(data.objects)
            break;
          case OXIMETRY_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: OXIMETRY_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'oximetry',
              measurementTypes: [
                { typeId: 46, label: 'duration_session', unit: 'min', ignoreForStats: false },
                { typeId: 47, label: 'oximetry_max', unit: '%', ignoreForStats: true },
                { typeId: 48, label: 'oximetry_min', unit: '%', ignoreForStats: true },
                { typeId: 49, label: 'oximetry_avg', unit: '%', ignoreForStats: false },
                { typeId: 50, label: 'pulse_rate_max', unit: 'bpm', ignoreForStats: true },
                { typeId: 51, label: 'pulse_rate_min', unit: 'bpm', ignoreForStats: true },
                { typeId: 52, label: 'pulse_rate_avg', unit: 'bpm', ignoreForStats: false },
              ],
            });
            break;
          case SPIROMETRY_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: SPIROMETRY_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'spirometry',
              measurementTypes: [
                { typeId: 21, label: 'forced_expiratory_volume_6_sec', unit: 'L', ignoreForStats: false },
                { typeId: 22, label: 'forced_expiratory_volume_1_sec', unit: 'L', ignoreForStats: false },
                { typeId: 23, label: 'fev1_fev6', unit: '', ignoreForStats: false },
                { typeId: 57, label: 'forced_mid_expiratory_flow_25_75', unit: 'L/s', ignoreForStats: false },
              ],
            });
            break;
          case TEMPERATURE_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: TEMPERATURE_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'temperature',
              measurementTypes: [
                { typeId: 11, label: 'body_temperature', unit: 'ºC', ignoreForStats: false },
              ],
            });
            break;
          case BODY_COMPOSITION_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: BODY_COMPOSITION_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'bodyComposition',
              measurementTypes: [
                { typeId: 1, label: 'body_weight', unit: 'Kg', ignoreForStats: false },
                { typeId: 8, label: 'body_mass_index', ignoreForStats: false },
                { typeId: 7, label: 'body_water_percentage', unit: '%', ignoreForStats: false },
                { typeId: 6, label: 'body_fat_percentage', unit: '%', ignoreForStats: false },
                { typeId: 53, label: 'body_muscle_mass', unit: '%', ignoreForStats: false },
              ],
            });
            break;
          case SARCOPENIA_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: SARCOPENIA_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'sarcopenia',
              measurementTypes: [
                { typeId: 6050, label: 'sarc_f', ignoreForStats: false },
                { typeId: 6004, label: 'hand_grip', unit: 'kgf', ignoreForStats: false },
                { typeId: 6052, label: 'body_muscle_mass', unit: 'Kg', ignoreForStats: false },
                { typeId: 6003, label: 'gait_speed', unit: 's', ignoreForStats: false },
              ],
            });
            break;
          case FRAILTY_PHENOTYPE_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: FRAILTY_PHENOTYPE_TYPE_ID,
              measurementTypeLabel: 'frailtyPhenotype',
              measurementTypes: [
                { typeId: 6001, label: 'frailty_exhaustion_result', unit: '', ignoreForStats: false },
                { typeId: 6002, label: 'frailty_physical_activity', unit: 'kcal', ignoreForStats: false },
                { typeId: 6003, label: 'frailty_walk_time', unit: 's', round: true, ignoreForStats: false },
                { typeId: 6004, label: 'frailty_dominant_strength', unit: 'kgf', ignoreForStats: false },
                { typeId: 6005, label: 'frailty_weight_loss', unit: 'kg', round: true, ignoreForStats: false },
              ],
            });
            break;
          case GLUCOSE_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: GLUCOSE_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'glucose',
              measurementTypes: [
                { typeId: 5, label: 'blood_glucose', unit: 'mg/dL', ignoreForStats: false },
                { typeId: 58, label: 'fasting', isBoolean: true, ignoreForStats: false },
              ],
            })
            break;
          case CHOLESTEROL_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: CHOLESTEROL_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'cholesterol',
              measurementTypes: [
                { typeId: 10001, label: 'cholesterol_total', unit: 'mg/dL', ignoreForStats: false },
                { typeId: 10002, label: 'hdl_cholesterol', unit: 'mg/dL', ignoreForStats: false },
                { typeId: 10003, label: 'ldl_cholesterol', unit: 'mg/dL', ignoreForStats: false },
                { typeId: 10004, label: 'triglycerides', unit: 'mg/dL', ignoreForStats: false },
                { typeId: 10005, label: 'cv_risk', unit: '%', ignoreForStats: false },
              ],
              measurementStatsData: this.glucoseStatsData,
            })
            break;
          case MAPA_24_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: MAPA_24_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'mapa24',
              measurementTypes: [],
              parseStatsData: false
            })
            break;
          case OPTOMETRY_MEASUREMENT_TYPE_ID:
            //this.parseOptometryData(data.objects)
            this.parseMeasurementData(data.objects, {
              measurementTypeId: OPTOMETRY_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'optometry',
              measurementTypes: [
                {typeId: 9050, label: 'astigmatism_left', unit: '', isBoolean: true, ignoreForStats: true},
                {typeId: 9051, label: 'astigmatism_right', unit: '', isBoolean: true, ignoreForStats: true},
                {typeId: 9052, label: 'duochrome', unit: '', isBoolean: true, ignoreForStats: true},
                {typeId: 9053, label: 'chromatic_wrong', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 9054, label: 'chromatic_correct', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 9055, label: 'contrast_left', unit: '%', isBoolean: false, ignoreForStats: true},
                {typeId: 9056, label: 'contrast_right', unit: '%', isBoolean: false, ignoreForStats: true},
                {typeId: 9057, label: 'macular_left', unit: '', isBoolean: true, ignoreForStats: true},
                {typeId: 9058, label: 'macular_right', unit: '', isBoolean: true, ignoreForStats: true},
                {typeId: 9059, label: 'acuity_left', unit: '%', isBoolean: false, ignoreForStats: true},
                {typeId: 9060, label: 'acuity_right', unit: '%', isBoolean: false, ignoreForStats: true},
                {typeId: 9069, label: 'optometry_result', unit: '', isBoolean: true, ignoreForStats: false}
              ],
              parseStatsData: true
            })
            break;
          case BODY_CIRCUMFERENCE_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: BODY_CIRCUMFERENCE_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'bodyCircumference',
              measurementTypes: [
                {typeId: 69, label: 'waist_perimeter', unit: 'cm', isBoolean: false, ignoreForStats: false},
                {typeId: 70, label: 'abdomen_perimeter', unit: 'cm', isBoolean: false, ignoreForStats: false},
                {typeId: 71, label: 'chest_perimeter', unit: 'cm', isBoolean: false, ignoreForStats: false},
                {typeId: 72, label: 'relaxed_arm_perimeter', unit: 'cm', isBoolean: false, ignoreForStats: false},
                {typeId: 73, label: 'thigh_perimeter', unit: 'cm', isBoolean: false, ignoreForStats: false},
                {typeId: 74, label: 'calf_perimeter', unit: 'cm', isBoolean: false, ignoreForStats: false},
              ],
              parseStatsData: true
            })
            break;
          case CHECKUP_ANAMNESE_MEASUREMENT_TYPE_ID:
            //dashboard_new_evollu.measurement_types.questions.1190
            this.parseMeasurementData(data.objects, {
              measurementTypeId: CHECKUP_ANAMNESE_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'checkupAnamnese',
              measurementTypes: [
                {typeId: 1186, label: 'question1186', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 1187, label: 'question1187', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 1188, label: 'question1188', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 1189, label: 'question1189', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 1190, label: 'question1190', unit: '', isBoolean: false, ignoreForStats: true},
              ],
              parseStatsData: false
            })

            break;
          case COPD_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: COPD_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'copd',
              measurementTypes: [
                {typeId: 21, label: 'forced_expiratory_volume_6_sec', unit: 'L', isBoolean: false, ignoreForStats: true},
                {typeId: 22, label: 'forced_expiratory_volume_1_sec', unit: 'L', isBoolean: false, ignoreForStats: false},
                {typeId: 30, label: 'forced_expiratory_volume_1_sec_predicted', unit: 'L', isBoolean: false, ignoreForStats: false},
                {typeId: 23, label: 'fev1_fev6', unit: '', isBoolean: false, ignoreForStats: false},
                {typeId: 57, label: 'forced_mid_expiratory_flow_25_75', unit: 'L/s', isBoolean: false, ignoreForStats: true},
                {typeId: 1015, label: 'copd_mmrc', unit: '', isBoolean: false, ignoreForStats: false},
                {typeId: 25, label: 'respiratory_crisis', unit: '', isBoolean: false, ignoreForStats: false},
                {typeId: 75, label: 'respiratory_hospitalization', unit: '', isBoolean: true, ignoreForStats: false},
              ],
              parseStatsData: true
            })

            break;
          case URINARY_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: URINARY_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'urinary',
              measurementTypes: [
                {typeId: 92, label: 'urinary_leu', unit: 'Cell/uL', isBoolean: false, ignoreForStats: false},
                {typeId: 93, label: 'urinary_ket', unit: '', isBoolean: false, ignoreForStats: true, needsTranslation: true, baseTranslationStr: 'dashboard_new_evollu.measurement_types.urinary_ket_values', round: false},
                {typeId: 94, label: 'urinary_nit', unit: '', isBoolean: false, ignoreForStats: false, needsTranslation: true, baseTranslationStr: 'dashboard_new_evollu.measurement_types.urinary_nit_values'},
                {typeId: 95, label: 'urinary_uro', unit: '', isBoolean: false, ignoreForStats: true, needsTranslation: true, baseTranslationStr: 'dashboard_new_evollu.measurement_types.urinary_uro_values'},
                {typeId: 96, label: 'urinary_bil', unit: 'umol/L', isBoolean: false, ignoreForStats: true},
                {typeId: 97, label: 'urinary_pro', unit: 'g/L', isBoolean: false, ignoreForStats: false},
                {typeId: 98, label: 'urinary_glu', unit: '', isBoolean: false, ignoreForStats: false, needsTranslation: true, baseTranslationStr: 'dashboard_new_evollu.measurement_types.urinary_glu_values'},
                {typeId: 99, label: 'urinary_sg', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 100, label: 'urinary_bld', unit: 'Cell/uL', isBoolean: false, ignoreForStats: false},
                {typeId: 101, label: 'urinary_ph', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 102, label: 'urinary_vc', unit: 'mmol/L', isBoolean: false, ignoreForStats: true},
              ],
              parseStatsData: true
            })

            break;
          case ADVANCED_GLUCOSE_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: ADVANCED_GLUCOSE_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'advancedGlucose',
              measurementTypes: [
                {typeId: 106, label: 'advanced_glucose_glucose', unit: 'mg/dL', isBoolean: false, ignoreForStats: false},
                {typeId: 107, label: 'advanced_glucose_hemoglobin_glycated', unit: '%', isBoolean: false, ignoreForStats: false},
                {typeId: 117, label: 'advanced_glucose_estimated_average', unit: 'mg/dL', isBoolean: false, ignoreForStats: false},
              ],
              parseStatsData: true
            })
            break;
          case BLOOD_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: BLOOD_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'blood',
              measurementTypes: [
                {typeId: 108, label: 'blood_hematocrit', unit: '%', isBoolean: false, ignoreForStats: false},
                {typeId: 109, label: 'blood_erythocytes', unit: 'million/mm3', isBoolean: false, ignoreForStats: false},
                {typeId: 110, label: 'blood_hemoglobin', unit: 'g/dL', isBoolean: false, ignoreForStats: false},
              ],
              parseStatsData: true
            })
            break;
          case REDOX_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: REDOX_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'redox',
              measurementTypes: [
                {typeId: 111, label: 'redox_fort', unit: 'FORT', isBoolean: false, ignoreForStats: false},
                {typeId: 112, label: 'redox_ford', unit: 'mmol/L', isBoolean: false, ignoreForStats: false},
                {typeId: 113, label: 'redox_uric_acid', unit: 'mg/dL', isBoolean: false, ignoreForStats: false},
                {typeId: 118, label: 'redox_index', unit: '', isBoolean: false, ignoreForStats: false},
              ],
              parseStatsData: true
            })
            break;
          case LIVER_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: LIVER_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'liver',
              measurementTypes: [
                {typeId: 115, label: 'liver_gpt_transsaminases', unit: 'U/L', isBoolean: false, ignoreForStats: false},
                {typeId: 116, label: 'liver_got_transsaminases', unit: 'U/L', isBoolean: false, ignoreForStats: false},
                {typeId: 119, label: 'liver_gpt_got_transsaminases', unit: '', isBoolean: false, ignoreForStats: false},
              ],
              parseStatsData: true
            })
            break;
          case BIOSIGNALS_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: BIOSIGNALS_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'biosigns',
              measurementTypes: [
                {typeId: 76, label: 'biosigns_heart_rate', unit: 'bpm', isBoolean: false, ignoreForStats: false},
                {typeId: 77, label: 'biosigns_variability_heart_rate', unit: 'ms', isBoolean: false, ignoreForStats: true},
                {typeId: 78, label: 'biosigns_bp_systolic', unit: 'mmHg', isBoolean: false, ignoreForStats: false},
                {typeId: 79, label: 'biosigns_bp_diastolic', unit: 'mmHg', isBoolean: false, ignoreForStats: false},
                {typeId: 80, label: 'biosigns_respiratory_rate', unit: 'bpm', isBoolean: false, ignoreForStats: true},
                {typeId: 81, label: 'biosigns_oxygen_saturation', unit: 'SpO₂%', isBoolean: false, ignoreForStats: true},
                {typeId: 82, label: 'biosigns_stress_index', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 83, label: 'biosigns_activity', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 84, label: 'biosigns_health', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 85, label: 'biosigns_relaxation', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 86, label: 'biosigns_metabolism', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 87, label: 'biosigns_sleep', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 88, label: 'biosigns_equilibrium', unit: '', isBoolean: false, ignoreForStats: true},
                {typeId: 89, label: 'biosigns_total_cholesterol', unit: 'mg/dL', isBoolean: false, ignoreForStats: false},
                {typeId: 90, label: 'biosigns_hemoglobin', unit: 'g/dL', isBoolean: false, ignoreForStats: false},
                {typeId: 91, label: 'biosigns_hba1c', unit: '%', isBoolean: false, ignoreForStats: false},
              ],
              parseStatsData: true
            })
            break;
          case ECG_MEASUREMENT_TYPE_ID:
            this.parseMeasurementData(data.objects, {
              measurementTypeId: ECG_MEASUREMENT_TYPE_ID,
              measurementTypeLabel: 'ecg',
              measurementTypes: [
                {typeId: 120, label: 'ecg_heart_rate_status', unit: 'bpm', isBoolean: false, ignoreForStats: false},
                {typeId: 121, label: 'ecg_bp_atrial_fibrillation', unit: '', isBoolean: true, ignoreForStats: false},
                {typeId: 122, label: 'ecg_measurement_status', unit: '', isBoolean: false, ignoreForStats: false, needsTranslation: true, baseTranslationStr: 'dashboard_new_evollu.measurement_types.ecg_measurement_status_values'},
              ],
              parseStatsData: true
            })
            break;
          default:
            console.error("Measure not handled - " + data.objects[0].measurementGroup.idMeasurementGroup)
        }
      } else {
        switch (measurementTypeId) {
          case BLOOD_PRESSURE_MEASUREMENT_TYPE_ID:
            this.loading.bloodPressure = false
            break;
          case OXIMETRY_MEASUREMENT_TYPE_ID:
            this.loading.oximetry = false
            break;
          case SPIROMETRY_MEASUREMENT_TYPE_ID:
            this.loading.spirometry = false
            break;
          case TEMPERATURE_MEASUREMENT_TYPE_ID:
            this.loading.temperature = false
            break;
          case BODY_COMPOSITION_MEASUREMENT_TYPE_ID:
            this.loading.bodyComposition = false
            break;
          case SARCOPENIA_MEASUREMENT_TYPE_ID:
            this.loading.sarcopenia = false
            break;
          case FRAILTY_PHENOTYPE_TYPE_ID:
            this.loading.frailtyPhenotype = false
            break;
          case GLUCOSE_MEASUREMENT_TYPE_ID:
            this.loading.glucose = false
            break;
          case CHOLESTEROL_MEASUREMENT_TYPE_ID:
            this.loading.cholesterol = false
            break;
          case MAPA_24_MEASUREMENT_TYPE_ID:
            this.loading.mapa24 = false
            break;
          case OPTOMETRY_MEASUREMENT_TYPE_ID:
            this.loading.optometry = false
            break;
          case BODY_CIRCUMFERENCE_MEASUREMENT_TYPE_ID:
            this.loading.bodyCircumference = false
            break;
          case CHECKUP_ANAMNESE_MEASUREMENT_TYPE_ID:
            this.loading.checkupAnamnese = false
            break;
          case COPD_MEASUREMENT_TYPE_ID:
            this.loading.copd = false
            break;
          case URINARY_MEASUREMENT_TYPE_ID:
            this.loading.urinary = false
            break;
          case ADVANCED_GLUCOSE_MEASUREMENT_TYPE_ID:
            this.loading.advancedGlucose = false
            break;
          case BLOOD_MEASUREMENT_TYPE_ID:
            this.loading.blood = false
            break;
          case REDOX_MEASUREMENT_TYPE_ID:
            this.loading.redox = false
            break;
          case LIVER_MEASUREMENT_TYPE_ID:
            this.loading.liver = false
            break;
          case BIOSIGNALS_MEASUREMENT_TYPE_ID:
            this.loading.biosigns = false
            break;
          case ECG_MEASUREMENT_TYPE_ID:
            this.loading.ecg = false
            break;
          default:
            console.error("Measure not handled")
        }
      }
    },
    parseMeasurementData: function (data, measurementConfig) {
      const {
        measurementTypeId,
        measurementTypeLabel,
        measurementTypes,
        parseStatsData = true,
      } = measurementConfig;

      let lastChartResults = []
      this[measurementTypeLabel + 'Data'] = [];
      lastChartResults = data[0].chartResults;

      let isIndividualResult = lastChartResults && lastChartResults.length > 0 ? lastChartResults.length === 1 : null

      let lastChartResultStr = 'N/A';
      let lastResults = [];
      if (lastChartResults && lastChartResults.length === 1) {
        lastChartResultStr = this.$t(`dashboard_new_evollu.parameters.graphs.legends.${lastChartResults[0].code.toLowerCase()}`);
        lastResults.push(lastChartResultStr);
      } else if (lastChartResults && lastChartResults.length > 1) {
        lastChartResults.forEach(res => {
          lastResults.push(this.$t(`dashboard_new_evollu.parameters.graphs.legends.${res.code.toLowerCase()}`));
        })
      }
      let statsData = {};
      if(data.length > 0) {
        data.forEach(elem => {
          //Handle device info
          let uniqueDevices = []
          if(elem.measurements) {
            const deviceInfos = elem.measurements
              .map(elem => elem.equipmentType)
              .filter(equipmentType => equipmentType != null);
            uniqueDevices = Array.from(
              new Map(deviceInfos.map(device => [`${device.idEquipmentType}-${device.name}`, device])).values()
            );
          }
          // ------------------
          const referenceValuesTables = elem.referenceValuesTables
          if(referenceValuesTables) {
            referenceValuesTables.measurementType = measurementTypeLabel
          }
          const measurementData = {
            id: elem.idMeasurement,
            measurementSeries: elem.measurementSeries,
            measurementTypeId,
            measurementType: measurementTypeLabel,
            created_at: moment(elem.date).format('YYYY-MM-DD HH:mm'),
            updated_at: moment(elem.date).format('YYYY-MM-DD HH:mm'),
            automatic: elem.automatic,
            appointment: elem.appointment,
            appointmentId: elem.appointmentId,
            last_chart_result: lastChartResultStr,
            lastResults: lastResults,
            isIndividualResult: isIndividualResult,
            lastChartResultObj: lastChartResults,
            referenceValuesTables: referenceValuesTables,
            notes: null,
            devicesInfo: uniqueDevices
          };

          measurementTypes.forEach(type => {
            let value = this.checkStringValueNotUndefinedAndReturn(
              elem.measurements ? elem.measurements.find(measurement => measurement.typeId === type.typeId) : 'N/A',
              type.unit,
              type.round,
              type.isBoolean
            );

            if(type.needsTranslation && type.baseTranslationStr) {
              if(value === null || value === '--') {
                measurementData[type.label] = "N/A"
              } else {
                measurementData[type.label] = this.$t(`${type.baseTranslationStr}.${value.toLowerCase().trim()}`, value)
              }
            } else {
              measurementData[type.label] = value
            }

            if(parseStatsData && !type.ignoreForStats) {
              statsData[type.label] = {}
              let relevantValue = this.checkStringValueNotUndefinedAndReturn(
                data[0].measurements.find(measurement => measurement.typeId === type.typeId),
                type.unit,
                type.round,
                type.isBoolean
              );

              if(type.needsTranslation && type.baseTranslationStr) {
                relevantValue = this.$t(`${type.baseTranslationStr}.${relevantValue.toLowerCase().trim()}`, relevantValue)
              }

              statsData[type.label]['last'] = relevantValue
            }
          });

          this[measurementTypeLabel + 'Data'].push(measurementData);
          this[measurementTypeLabel + 'StatsData'] = { ...statsData };

        });
      }

      this.loading[measurementTypeLabel] = false;
    },
    onConfirmDeletePatient: function () {
      OneCareService.deletePatient(this.patientDetails.idPerson)
        .then(() => {
          this.showToast(this.$t('dashboard_new_evollu.messages.successful_delete'), this.$store.state.successToastOptions)
          this.$router.push({path: '/check-up_plus/checkup_plus/patients'})
        })
        .catch(() => {
          this.showToast(this.$t('dashboard_new_evollu.messages.something_went_wrong'), this.$store.state.errorToastOptions)
        })
      this.showDeletePatient = false
    },
    onCancelDeletePatient: function () {
      this.showDeletePatient = false
    },
    onConfirmChangeStatus: function () {
      OneCareService.changePatientStatus(this.patientDetails.idPerson)
        .then(() => {
          this.showToast(this.$t('dashboard_new_evollu.messages.successful_status_change'), this.$store.state.successToastOptions)
          this.$router.push({path: '/check-up_plus/checkup_plus/patients'})
        })
        .catch(() => {
          this.showToast(this.$t('dashboard_new_evollu.messages.something_went_wrong_status_change'), this.$store.state.errorToastOptions)
        })
      this.showStatusChangePatientModal = false
    },
    onCancelChangeStatus: function () {
      this.showStatusChangePatientModal = false
    },
    checkValueNotUndefinedAndReturn: function (val, type, unit = '', isBoolean = false) {
      if (val && val[type]) {
        return isBoolean ? this.parseBoolean(`${val[type]} ${unit.toString()}`) : `${val[type]} ${unit.toString()}`
      } else return "--"
    },
    onCancelEdit: function () {
      this.showUpdatePatient = false
      this.loadData(false)
    },
    checkStringValueNotUndefinedAndReturn: function (val, unit = '', round = false, isBoolean = false) {
      if (val && val.stringValue) {
        if (round) {
          let roundedVal = this.roundStringValueToNearestTenth(val.stringValue)
          return isBoolean ? this.parseBoolean(`${roundedVal} ${unit}`) : `${roundedVal} ${unit}`
        } else {
          return isBoolean ? this.parseBoolean(`${val.stringValue} ${unit}`) : `${val.stringValue} ${unit}`
        }
      } else return "--"
    },
    roundStringValueToNearestTenth: function (val) {
      if (val === null || val === undefined || val === '') {
        return "--"
      } else if (!isNaN(val) && val.indexOf('.') != -1) {
        if (val.split(".")[1].length > 1) {
          let roundedFloat = Math.round(10 * parseFloat(val)) / 10
          return roundedFloat.toString()
        }
      }
      return val
    },
    parseBoolean: function (val) {
      const value = typeof val === "string" ? parseInt(val) : val
      return value === 1 ? this.$t('clinical.labels.yes') : this.$t('clinical.labels.no')
    },
    addUnderscoreToUppercase: function (inputString) {
      var modifiedString = "";

      for (var i = 0; i < inputString.length; i++) {
        var currentChar = inputString.charAt(i);

        if (currentChar === currentChar.toUpperCase() && /[A-Z]/.test(currentChar)) {
          // If the character is uppercase, add an underscore and the lowercase version
          modifiedString += "_" + currentChar.toLowerCase();
        } else {
          // If the character is not uppercase, keep it as is
          modifiedString += currentChar;
        }
      }

      return modifiedString;
    },
    handleOneCareAppPassword: function() {
      this.showOneCareAppPasswordModal = true
    },
    handleCanSeeMeasurements: async function () {
      if(!this.patientDetails) this.canSeeMeasurements = false

      const patientEntityId = this.patientDetails.facilitiesEvollu[0].entity_id
      if (patientEntityId === null || patientEntityId === undefined) {
        this.canSeeMeasurements = false
      }
      //this.canSeeMeasurements = this.checkupPlusService.user_permissions.some(p => p.entity_id === patientEntityId && p.access_type >= 2 && p.info_type === 120)
      this.canSeeMeasurements = true
    },
  },
  computed: {
    ...mapState({
      measurementTypesInfo (state, getters) {
        return getters[`checkup/measurementTypesInfo`] || null
      }
    }),
    countries: function () {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === "gb") {
          code = "en"
        } else if (code.toLowerCase() === 'cz') {
          code = 'cs'
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`))
      }
      let vueI18nLocale = Vue.i18n.locale().toLowerCase()
      switch (vueI18nLocale) {
        case 'gb':
          vueI18nLocale = 'en'
          break;
        case 'cz':
          vueI18nLocale = 'cs'
          break;
      }
      let tempCountries = countries.getNames(vueI18nLocale)
      let countriesList = []
      for(const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key
        })
      }
      return countriesList
      //return CountryList.filter(country => this.$store.state.countries.allowed.includes(country.code))
      //return CountryList
    },
    selectedCardData: function () {
      if (this.selectedCardIdentifier) {
        return {
          identifier: this.addUnderscoreToUppercase(this.selectedCardIdentifier),
          originalIdentifier: this.selectedCardIdentifier,
          data: this[`${this.selectedCardIdentifier}Data`],
          statsData: this[`${this.selectedCardIdentifier}StatsData`],
          loading: this.loading[`${this.selectedCardIdentifier}`],
          chartData: this[`${this.selectedCardIdentifier}ChartData`] || {},
        }
      } else {
        return null
      }
    },
    measurementCardsIdentifiers: {
      get() {
        const userConfigVisible = this.originalUserConfig
          .filter(({ is_hidden }) => !is_hidden)
          .map(({ checkup_measurement_group_id }) => checkup_measurement_group_id);

        const measurements = this.userEntityMeasurementGroupsPermited
          .filter(({ measurementGroupId }) => userConfigVisible.includes(measurementGroupId))
          .sort((a, b) =>
            userConfigVisible.indexOf(a.measurementGroupId) - userConfigVisible.indexOf(b.measurementGroupId)
          );

        return measurements.map(elem => ({
          identifier: this.addUnderscoreToUppercase(elem.slug),
          originalIdentifier: elem.slug,
          data: this[`${elem.slug}Data`],
          statsData: this[`${elem.slug}StatsData`],
          loading: this.loading[`${elem.slug}`],
          measurementTypeId: elem.measurementGroupId
        }));
      },
      set(newOrder) {
        // update originalUserConfig order based on new draggable list
        const newOrderIds = newOrder.map(item => item.measurementTypeId);

        this.userConfig = this.userConfig
          .slice() // clone to preserve reactivity
          .sort((a, b) => {
            const aIndex = newOrderIds.indexOf(a.checkup_measurement_group_id);
            const bIndex = newOrderIds.indexOf(b.checkup_measurement_group_id);
            // Move visible items according to new order, others stay in place
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;
            return aIndex - bIndex;
          });

        this.updateDraggableCardOrder()

        this.originalUserConfig = this.userConfig

        //Update the config on the server
        this.handleSaveUserConfig(false)
      }
    },
    measurementCardsIdentifiersOld: function () {
      //TODO Delete when new approach is tested aand approved
      /*const measurementsTypesIds = {
        audiology: TONAL_TEST_MEASUREMENT_TYPE_ID,
        bloodPressure: BLOOD_PRESSURE_MEASUREMENT_TYPE_ID,
        oximetry: OXIMETRY_MEASUREMENT_TYPE_ID,
        glucose: GLUCOSE_MEASUREMENT_TYPE_ID,
        spirometry: SPIROMETRY_MEASUREMENT_TYPE_ID,
        temperature: TEMPERATURE_MEASUREMENT_TYPE_ID,
        bodyComposition: BODY_COMPOSITION_MEASUREMENT_TYPE_ID,
        sarcopenia: SARCOPENIA_MEASUREMENT_TYPE_ID,
        frailtyPhenotype: FRAILTY_PHENOTYPE_TYPE_ID,
        cholesterol: CHOLESTEROL_MEASUREMENT_TYPE_ID,
        mapa24: MAPA_24_MEASUREMENT_TYPE_ID,
        optometry: OPTOMETRY_MEASUREMENT_TYPE_ID,
        bodyCircumference: BODY_CIRCUMFERENCE_MEASUREMENT_TYPE_ID,
        checkupAnamnese: CHECKUP_ANAMNESE_MEASUREMENT_TYPE_ID,
        copd: COPD_MEASUREMENT_TYPE_ID,
        urinary: URINARY_MEASUREMENT_TYPE_ID,
        advancedGlucose: ADVANCED_GLUCOSE_MEASUREMENT_TYPE_ID,
        blood: BLOOD_MEASUREMENT_TYPE_ID,
        redox: REDOX_MEASUREMENT_TYPE_ID,
        liver: LIVER_MEASUREMENT_TYPE_ID,
        biosignals: BIOSIGNALS_MEASUREMENT_TYPE_ID,
        ecg: ECG_MEASUREMENT_TYPE_ID
      }

      const measurements = ['checkupAnamnese', 'audiology', 'bloodPressure', 'oximetry', 'glucose', 'spirometry', 'temperature', 'bodyComposition', 'sarcopenia', 'frailtyPhenotype', 'cholesterol', 'mapa24', 'optometry', 'bodyCircumference', 'copd', 'urinary', 'advancedGlucose', 'blood', 'redox', 'liver', 'biosignals', 'ecg']

      return measurements.map(elem => {
        return {
          identifier: this.addUnderscoreToUppercase(elem),
          originalIdentifier: elem,
          data: this[`${elem}Data`],
          statsData: this[`${elem}StatsData`],
          loading: this.loading[`${elem}`],
          measurementTypeId: measurementsTypesIds[elem]
        }
      })*/

      const userConfigVisible = this.originalUserConfig
        .filter(({ is_hidden }) => !is_hidden)
        .map(({ checkup_measurement_group_id }) => checkup_measurement_group_id);

      /*const measurements = this.userEntityMeasurementGroupsPermited
        .filter(({ measurementGroupId }) => userConfigVisible.includes(measurementGroupId));*/
      const measurements = this.userEntityMeasurementGroupsPermited
        .filter(({ measurementGroupId }) => userConfigVisible.includes(measurementGroupId))
        .sort((a, b) =>
          userConfigVisible.indexOf(a.measurementGroupId) - userConfigVisible.indexOf(b.measurementGroupId)
        );

      return measurements.map(elem => {
        return {
          identifier: this.addUnderscoreToUppercase(elem.slug),
          originalIdentifier: elem.slug,
          data: this[`${elem.slug}Data`],
          statsData: this[`${elem.slug}StatsData`],
          loading: this.loading[`${elem.slug}`],
          measurementTypeId: elem.measurementGroupId
        }
      })
    },
    handlePatientName: function () {
      //patientDetails ? `${patientDetails.firstName} ${patientDetails.surname}` : ''
      if (this.patientDetails === null) return ''
      let name = ''
      this.patientDetails.firstName ? name = name.concat(this.patientDetails.firstName) : name = name.concat(this.patientDetails.name)
      if (this.patientDetails.surname) {
        name = name.concat(` ${this.patientDetails.surname}`)
      }
      return name
    },
    checkupPlusService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.onecare_server) || null
    },
    peopleManagerService: function() {
      return this.$store.state.services.find(service => service.url === this.$store.state.people_manager_server) || null
    },
    hasSomeActionsPermissions: function () {
      return this.canUpdateUser || this.canDeletePatient
    },
    canUpdateUser: function () {
      //const patientEntities = this.patientDetails.facilitiesEvollu.map(elem => elem.entity_id)
      if(!this.patientDetails) return false
      const patientEntityId = this.patientDetails.facilitiesEvollu[0].entity_id

      if (patientEntityId === null || patientEntityId === undefined || this.peopleManagerService === null || this.patientDetails.peopleManagerId === null) {
        return false
      }
      return this.peopleManagerService.user_permissions.some(p => p.access_type >= 2 && p.info_type === PEOPLE_MANAGER_LIST_INFO_TYPE && (p.entity_id === null || p.entity_id === parseInt(patientEntityId)))
    },
    canCreateMeasurement: function () {
      if(!this.patientDetails) return false
      //return this.canUpdateUser
      //const patientEntities = this.patientDetails.facilitiesEvollu.map(elem => elem.entity_id)
      const patientEntityId = this.patientDetails.facilitiesEvollu[0].entity_id
      if (patientEntityId === null || patientEntityId === undefined) {
        return false
      }
      return this.checkupPlusService.user_permissions.some(p => p.entity_id === patientEntityId && p.access_type >= 2 && p.info_type === 120)
    },
    canDeleteMeasurement: function () {
      if(!this.patientDetails) return false
      //return this.canUpdateUser
      //const patientEntities = this.patientDetails.facilitiesEvollu.map(elem => elem.entity_id)
      const patientEntityId = this.patientDetails.facilitiesEvollu[0].entity_id
      if (patientEntityId === null || patientEntityId === undefined) {
        return false
      }
      return this.checkupPlusService.user_permissions.some(p => p.entity_id === patientEntityId && p.access_type >= 2 && p.info_type === 120)
    },
    canDeletePatient: function () {
      if(!this.patientDetails) return false
      const patientEntityId = this.patientDetails.facilitiesEvollu[0].entity_id
      if (patientEntityId === null || patientEntityId === undefined) {
        return false
      }
      return this.checkupPlusService.user_permissions.some(p => p.entity_id === patientEntityId && p.access_type >= 3 && p.info_type === 120)
    },
    hasPermissionToSendReportToPatient: function () {
      const patientEntityId = this.patientDetails.facilitiesEvollu[0].entity_id
      if (patientEntityId === null || patientEntityId === undefined) {
        return false
      }
      return this.checkupPlusService.user_permissions.some(p => p.entity_id === patientEntityId && p.access_type === 1 && p.info_type === 120)
    },
    hasPermissionToSendReportToPatientAndOthers: function () {
      const patientEntityId = this.patientDetails.facilitiesEvollu[0].entity_id
      if (patientEntityId === null || patientEntityId === undefined) {
        return false
      }
      return this.checkupPlusService.user_permissions.some(p => p.entity_id === patientEntityId && p.access_type >= 2 && p.info_type === 120)
    },
    bloodPressureChartData: function () {
      let reversedData = [...this.bloodPressureData]
      reversedData = reversedData.reverse()

      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.systolic'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.systolic)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.diastolic'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.diastolic)).reverse(),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.heart_rate'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.heart_rate)).reverse(),
          }
        ]
      }
    },
    oximetryChartData: function () {
      let reversedData = [...this.oximetryData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.duration_session_short'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.duration_session)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.oximetry_max_short'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.oximetry_max)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.oximetry_min_short'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.oximetry_min)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.oximetry_avg_short'),
            color: '#ffe6df',
            data: reversedData.map(elem => parseInt(elem.oximetry_avg)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_max_short'),
            color: '#ad9983',
            data: reversedData.map(elem => parseInt(elem.pulse_rate_max)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_min_short'),
            color: '#975ac5',
            data: reversedData.map(elem => parseInt(elem.pulse_rate_min)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_avg_short'),
            color: '#de9347',
            data: reversedData.map(elem => parseInt(elem.pulse_rate_avg)),
          },
        ]
      }
    },
    spirometryChartData: function () {
      let reversedData = [...this.spirometryData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_6_sec_short'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.forced_expiratory_volume_6_sec)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_1_sec_short'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.forced_expiratory_volume_1_sec)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.fev1_fev6_short'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.fev1_fev6)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.forced_mid_expiratory_flow_25_75_short'),
            color: '#ffe6df',
            data: reversedData.map(elem => parseInt(elem.forced_mid_expiratory_flow_25_75)),
          },
        ]
      }
    },
    temperatureChartData: function () {
      let reversedData = [...this.temperatureData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.body_temperature_short'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.body_temperature)),
          }
        ]
      }
    },
    bodyCompositionChartData: function () {
      let reversedData = [...this.bodyCompositionData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.body_weight_short'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.body_weight)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.body_mass_index_short'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.body_mass_index)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.body_water_percentage_short'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.body_water_percentage)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.body_fat_percentage_short'),
            color: '#ffe6df',
            data: reversedData.map(elem => parseInt(elem.body_fat_percentage)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.body_muscle_mass_short'),
            color: '#ad9983',
            data: reversedData.map(elem => parseInt(elem.body_muscle_mass)),
          },
        ]
      }
    },
    glucoseChartData: function () {
      let reversedData = [...this.glucoseData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.blood_glucose_short'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.blood_glucose)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.fasting_short'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.fasting)),
          },
        ]
      }
    },
    sarcopeniaChartData: function () {
      let reversedData = [...this.sarcopeniaData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.sarc_f_short'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.sarc_f)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.hand_grip_short'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.hand_grip)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.body_muscle_mass_short'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.body_muscle_mass)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.gait_speed_short'),
            color: '#ffe6df',
            data: reversedData.map(elem => parseInt(elem.gait_speed)),
          },
        ]
      }
    },
    frailtyPhenotypeChartData: function () {
      let reversedData = [...this.frailtyPhenotypeData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.frailty_physical_activity_short'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.frailty_physical_activity)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.frailty_walk_time_short'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.frailty_walk_time)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.frailty_dominant_strength_short'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.frailty_dominant_strength)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.frailty_weight_loss_short'),
            color: '#ffe6df',
            data: reversedData.map(elem => parseInt(elem.frailty_weight_loss)),
          },
        ]
      }
    },
    cholesterolChartData: function () {
      let reversedData = [...this.cholesterolData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.cholesterol_total'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.cholesterol_total)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.hdl_cholesterol'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.hdl_cholesterol)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.ldl_cholesterol'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.ldl_cholesterol)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.triglycerides'),
            color: '#ffe6df',
            data: reversedData.map(elem => parseInt(elem.triglycerides)),
          },
        ]
      }
    },
    mapa24ChartData: function () {
      return []
    },
    bodyCircumferenceChartData: function () {
      let reversedData = [...this.bodyCircumferenceData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.waist_perimeter_short'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.waist_perimeter)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.abdomen_perimeter_short'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.abdomen_perimeter)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.chest_perimeter_short'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.chest_perimeter)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.relaxed_arm_perimeter_short'),
            color: '#ffe6df',
            data: reversedData.map(elem => parseInt(elem.relaxed_arm_perimeter)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.thigh_perimeter_short'),
            color: '#ad9983',
            data: reversedData.map(elem => parseInt(elem.thigh_perimeter)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.calf_perimeter_short'),
            color: '#de9347',
            data: reversedData.map(elem => parseInt(elem.calf_perimeter)),
          },
        ]
      }
    },
    copdChartData: function () {
      let reversedData = [...this.copdData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_6_sec_short'),
            color: '#9859a9',
            data: reversedData.map(elem => elem.forced_expiratory_volume_6_sec),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_1_sec_short'),
            color: '#66aca9',
            data: reversedData.map(elem => elem.forced_expiratory_volume_1_sec),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.fev1_fev6_short'),
            color: '#74af8c',
            data: reversedData.map(elem => elem.fev1_fev6),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.forced_mid_expiratory_flow_25_75_short'),
            color: '#ffe6df',
            data: reversedData.map(elem => elem.forced_mid_expiratory_flow_25_75),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_1_sec_predicted_short'),
            color: '#ad9983',
            data: reversedData.map(elem => elem.forced_expiratory_volume_1_sec_predicted),
          },
        ]
      }
    },
    urinaryChartData: function () {
      let reversedData = [...this.urinaryData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_leu'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.urinary_leu)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_ket'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.urinary_ket)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_nit'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.urinary_nit)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_uro'),
            color: '#ffe6df',
            data: reversedData.map(elem => parseInt(elem.urinary_uro)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_bil'),
            color: '#ad9983',
            data: reversedData.map(elem => parseInt(elem.urinary_bil)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_pro'),
            color: '#de9347',
            data: reversedData.map(elem => parseInt(elem.urinary_pro)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_glu'),
            color: '#4754de',
            data: reversedData.map(elem => parseInt(elem.urinary_glu)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_sg'),
            color: '#b26185',
            data: reversedData.map(elem => parseInt(elem.urinary_sg)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_bld'),
            color: '#caed85',
            data: reversedData.map(elem => parseInt(elem.urinary_bld)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_ph'),
            color: '#6f4a00',
            data: reversedData.map(elem => parseInt(elem.urinary_ph)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.urinary_vc'),
            color: '#005b08',
            data: reversedData.map(elem => parseInt(elem.urinary_vc)),
          },
        ]
      }
    },
    biosignsChartData: function () {
      let reversedData = [...this.biosignsData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_heart_rate_short'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.biosigns_heart_rate)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_variability_heart_rate_short'),
            color: '#66aca9',
            data: reversedData.map(elem => parseInt(elem.biosigns_variability_heart_rate)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_bp_systolic_short'),
            color: '#74af8c',
            data: reversedData.map(elem => parseInt(elem.biosigns_bp_systolic)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_bp_diastolic_short'),
            color: '#ffe6df',
            data: reversedData.map(elem => parseInt(elem.biosigns_bp_diastolic)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_respiratory_rate_short'),
            color: '#ad9983',
            data: reversedData.map(elem => parseInt(elem.biosigns_respiratory_rate)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_oxygen_saturation_short'),
            color: '#de9347',
            data: reversedData.map(elem => parseInt(elem.biosigns_oxygen_saturation)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_stress_index_short'),
            color: '#4754de',
            data: reversedData.map(elem => parseInt(elem.biosigns_stress_index)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_activity_short'),
            color: '#b26185',
            data: reversedData.map(elem => parseInt(elem.biosigns_activity)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_health_short'),
            color: '#caed85',
            data: reversedData.map(elem => parseInt(elem.biosigns_health)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_relaxation_short'),
            color: '#6f4a00',
            data: reversedData.map(elem => parseInt(elem.biosigns_relaxation)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_metabolism_short'),
            color: '#005b08',
            data: reversedData.map(elem => parseInt(elem.biosigns_metabolism)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_sleep_short'),
            color: '#4bafd2',
            data: reversedData.map(elem => parseInt(elem.biosigns_sleep)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_equilibrium_short'),
            color: '#23b678',
            data: reversedData.map(elem => parseInt(elem.biosigns_equilibrium)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_total_cholesterol_short'),
            color: '#d2de32',
            data: reversedData.map(elem => parseInt(elem.biosigns_total_cholesterol)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_hemoglobin_short'),
            color: '#f57e68',
            data: reversedData.map(elem => parseInt(elem.biosigns_hemoglobin)),
          },
          {
            name: this.$t('dashboard_new_evollu.measurement_types.biosigns_hba1c_short'),
            color: '#cb56c9',
            data: reversedData.map(elem => parseInt(elem.biosigns_hba1c)),
          },
        ]
      }
    },
    ecgChartData: function () {
      let reversedData = [...this.ecgData]
      reversedData = reversedData.reverse()
      return {
        labels: reversedData.map(elem => elem.created_at),
        datasets: [
          {
            name: this.$t('dashboard_new_evollu.measurement_types.ecg_heart_rate_status'),
            color: '#9859a9',
            data: reversedData.map(elem => parseInt(elem.ecg_heart_rate_status) || 0),
          }
        ]
      }
    },
  },
}
</script>

<style lang="scss">
.selected-card-bg .row .va-card {
  background: #dee2e6;
}
</style>

<style scoped>
.em {
  font-style: italic;
}

.recent-update {
  color: #73d30a;
}


/*.overlay-loader {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.8;
  filter: blur(5px);
  z-index: 2;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-message {
  position: relative;
  z-index: 3;
  font-size: 20px;
  color: black;
  text-align: center;
  filter: none;
}*/

.overlay-loader {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.blur-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.8;
  filter: blur(5px);
  z-index: 1; /* Background layer */
}

.overlay-message {
  position: relative;
  z-index: 3; /* Ensure the message is above the blur */
  font-size: 20px;
  color: black;
  text-align: center;
}

.configuration-gear:hover{
  color: #29C4AABF;
}

.config-dropdown {
  margin-top: 25px;
  position: absolute;
  background: white;
  z-index: 9999;
  padding: 1rem;
  border-radius: 8px;
  min-width: 250px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.card-option {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.drag-handle {
  cursor: grab;
  margin-right: 8px;
}

</style>
